import { DropDownFilterProps, DropDownFilter } from 'framework/list';
import BusinessFunctionDropdown from './input/BusinessFunctionDropdown';

const BusinessFunctionFilter = (props: Omit<DropDownFilterProps, 'children'>) => {
  return (
    <DropDownFilter {...props}>
      <BusinessFunctionDropdown {...props} />
    </DropDownFilter>
  );
};

export default BusinessFunctionFilter;
